﻿/**
 * How staff see the title of a supplier-quoted line (v1 completion E, Ben's ruling 13 Oct).
 *
 * The title is stored exactly as the person typed it, and customers and suppliers read it plain (the customer's
 * quote and order pages, the purchase order). Staff-facing screens and lists show it with this fixed prefix so
 * bespoke work stands out. The prefix is added here, in the one place, never per screen and never stored.
 */
export const BESPOKE_TITLE_PREFIX = "Bespoke: ";

/** The title for a staff screen: prefixed when the line is a supplier-quoted one, else as it is. */
export function staffLineTitle(
  title: string,
  isSupplierQuoted: boolean,
): string {
  return isSupplierQuoted ? `${BESPOKE_TITLE_PREFIX}${title}` : title;
}
